
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/packet-log",
      function () {
        return require("private-next-pages/packet-log.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/packet-log"])
      });
    }
  